module.exports = __webpack_public_path__ + "static/media/fly0114.3d182e9c.webp";